var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M.254 1.642C-.116 1.233-.077.609.342.248c.387-.334.962-.327 1.34-.002l.09.088L6 5 1.772 9.666c-.37.41-1.01.448-1.43.086-.387-.333-.45-.89-.166-1.296l.078-.098L3.296 5 .254 1.642z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4686ce58.svg";
export { ForwardRef as ReactComponent };